export const mobileCheck = () => {
    let check = false;
    ((a) => {
        if (
            //eslint-disable-next-line
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            //eslint-disable-next-line
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);

    return check;
};

export const getSelectedProduct = (
    planningData,
    selectedCategoryIndex,
    selectedState
) => {
    let selectedProductionArray = [];
    if (!planningData[selectedCategoryIndex]) {
        let dataArray = [];

        // 改成用 foreach
        selectedState.forEach((selectedItem, selectedIndex) => {
            planningData.category[selectedCategoryIndex].categoryList.forEach(
                (item, index) => {
                    if (selectedIndex === index) {
                        item.itemList.forEach((itemInList, indexInList) => {
                            let realItemIndex =
                                selectedItem.showIndex ===
                                selectedItem.realJsonIndex
                                    ? selectedItem.showIndex
                                    : selectedItem.realJsonIndex;
                            if (realItemIndex === indexInList) {
                                let dataItem = {
                                    sku: "",
                                    qty: 1,
                                };
                                dataItem.sku = itemInList.sku;
                                dataItem.qty = !itemInList.qty
                                    ? 0
                                    : itemInList.qty;
                                dataArray.push(Object.assign(dataItem));
                            }
                        });
                    }
                }
            );
        });
        // console.log(dataArray);
        selectedProductionArray = dataArray;
    }

    return selectedProductionArray;
};

export const getSimpleProductionUrl = (selectedProduction) => {
    // 組出要去打 api 的 url sku,sku 最後一個沒有 ,
    let urlStr = "";
    selectedProduction.forEach((element) => {
        // 把 sku: 0 的篩選掉
        if (element.sku !== "0") {
            urlStr += element.sku + ",";
        }
    });

    urlStr = urlStr.slice(0, -1);

    return urlStr;
};

export const computeAmount = (resData, selectedData) => {
    // console.log('resData', resData);
    // console.log('selectedData', selectedData);
    let amount = 0;
    selectedData.forEach((selectedElement) => {
        resData.forEach((resDataElement) => {
            if (resDataElement.sku === selectedElement.sku) {
                amount += resDataElement.salePrice * selectedElement.qty;
            }
        });
    });
    // console.log(amount);
    return amount;
};

export const computeListData = (planningData, selectedData) => {
    // console.log('planningData', planningData);
    // console.log('selectedData', selectedData);
    let listJson = [];

    selectedData.forEach((selectedElement, selectedIndex) => {
        planningData.categoryList[selectedIndex].itemList.forEach(
            (itemListItem, itemListIndex) => {
                if (selectedElement.realJsonIndex === itemListIndex) {
                    let listItem = {
                        sku: "0",
                        image: "",
                        qty: 0,
                        name: "",
                    };
                    listItem.sku = itemListItem.sku;
                    listItem.image = itemListItem.image;
                    listItem.qty = itemListItem.qty;
                    listItem.name = itemListItem.itemName;
                    listJson = [...listJson, listItem];
                }
            }
        );
    });
    // console.log(listJson);
    return listJson;
};

export const computeProductName = (
    listData,
    selectedCategoryIndex,
    planningData
) => {
    // 組出全部的品名
    // let nameArray = [];
    // listData.forEach((listEle) => {
    //   nameArray.push(listEle.name)
    // })
    // let nameArrayToString = nameArray.join()

    // return nameArrayToString;

    // 改成知道他是第幾個分類秀出對應文字就好
    let categoryWording = "";
    categoryWording =
        planningData.category[selectedCategoryIndex].categoryTypeName;

    return categoryWording;
};

// number / currency convert function
export const numberToCurrency = (number) => {
    const n = Number(number);
    if (Number.isNaN(n) || number === "") {
        return "";
    }
    return `$${n.toFixed(0).replace(/./g, (c, i, a) => {
        const currency =
            i && c !== "." && (a.length - i) % 3 === 0
                ? `, ${c}`.replace(/\s/g, "")
                : c;
        return currency;
    })}`;
};

export const currencyToNumber = (currency) =>
    Number(currency.replace(/[^0-9.-]+/g, ""));

export const imgSrcAddPrefix = (imgSrc) => {
    const prefix = "/_ui/responsive/theme-trplus/app/js/situation-sales/";
    if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
    ) {
        return imgSrc;
    }
    return prefix + imgSrc;
};

export const returnExcludeCategoryList = (
    SelectedCategoryFacets,
    selectedState
) => {
    let excludeCategoryList = [];

    selectedState.forEach((item, index) => {
        if (index === 0 || index === 4) {
            excludeCategoryList =
                SelectedCategoryFacets[index].itemList[item.showIndex]
                    .excludeCategoryList;
        }
    });

    return excludeCategoryList;
};

export const returnExcludeItemList = (
    SelectedCategoryFacets,
    selectedState
) => {
    let excludeItemList = [];

    selectedState.forEach((item, index) => {
        if (index === 0 || index === 4) {
            excludeItemList =
                SelectedCategoryFacets[index].itemList[item.showIndex]
                    .excludeItemList;
        }
    });

    return excludeItemList;
};
